module.exports = __webpack_public_path__ + "img/6_165.2d5bf786.png";